export default __webpack_public_path__ + "static/media/indicadores.f46403e5.svg";